export function debounce(func, wait) {
  let to = null;
  return (...args) => {
    if (to) {
      clearTimeout(to);
    }

    to = setTimeout(() => {
      to = null;
      func(...args);
    }, wait);
  };
}
